module.exports = __webpack_public_path__ + "img/icons.afd5672.svg";